import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import AssociationMultiDropDownViewModelType from '@/ViewModels/Controls/AssociationMultiDropDownViewModel';
import MultiSelectDropDownListType from '@/Controls/MultiSelectDropDownList';
import LinkType from '@/Controls/Link';

export default class AssociationMultiDropDown extends Control {

    private MultiSelectDropDownList = ComponentManager.getControl<typeof MultiSelectDropDownListType>('MultiSelectDropDownList');
    private Link = ComponentManager.getControl<typeof LinkType>('Link');

    private jQueryControl: JQuery;
    public multiSelectDropDownList: MultiSelectDropDownListType;
    public linkCreate: LinkType;
    public linkSelect: LinkType;
    public linkDelete: LinkType;

    public constructor(private viewModel: AssociationMultiDropDownViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'associationmultidropdown',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    var styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    var states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.multiSelectDropDownList != null) {
            this.multiSelectDropDownList = new this.MultiSelectDropDownList(this.viewModel.multiSelectDropDownList);
            var tuple = this.multiSelectDropDownList.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.linkCreate != null) {
            this.linkCreate = new this.Link(this.viewModel.linkCreate);
            var tuple = this.linkCreate.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.linkDelete != null) {
            this.linkDelete = new this.Link(this.viewModel.linkDelete);
            var tuple = this.linkDelete.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }

    public addLabelReference(label: JQuery) {
        return this.multiSelectDropDownList.addLabelReference(label);
    }
}

ComponentManager.setControl('AssociationMultiDropDown', AssociationMultiDropDown, 'RADPresentation.HTMLClient.DefaultViewExtensions');